import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const VoiceLibraryMobileContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70dvh;
  padding: 24px 8px;
  gap: 24px;

  .icon-mobile-web {
    height: 100px;
    width: 148.13px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .button-copy-url {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${COLOR.darkBlue};
    background-color: ${COLOR.yellow.default};
    border-radius: 12px;
    height: 48px;
    width: 100%;
  }

  .copy-icon {
    color: ${COLOR.darkBlue};
    width: 24px;
    height: 24px;
  }

  .checked-icon {
    border-radius: 50%;
    background-color: ${COLOR.darkBlue};
    color: ${COLOR.yellow.default};
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .noti-mobile {
    word-wrap: break-word;
    text-align: center;
  }

  .download-app-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .download-app {
      display: flex;
      gap: 8px;
      align-items: center;

      .qr-code {
        width: 160px;
      }

      .download-button-container {
        display: flex;
        flex-direction: column;
        gap: 14px;
      }

      .download-button {
        padding: 0;
      }
    }
  }
`;
